<template>
  <div>
    <div class="content-header">
      <div class="container-fluid">
        <h1 class="m-0 text-dark">Edit Lender</h1>
      </div>
    </div>

    <div class="content">
      <div class="container-fluid">
        <div class="col-12">
          <form @submit.prevent="updateLender">
            <div class="form-group">
              <label for="exampleInputNama">Nama</label>
              <input type="text" class="form-control text-left" v-model="lenderForm.name" />
            </div>
            <div class="form-group">
              <label for="exampleInputEmail">Email</label><br>
              {{ lenderForm.email }}
            </div>
            <div class="form-group">
              <label for="exampleInputHandphone">No Hp</label>
              <input type="text" class="form-control text-left" v-model="lenderForm.phone" />
            </div>
            <div class="form-group">
              <label for="exampleInputNama">Status</label>
              <select class="form-control" v-model="lenderForm.status">
                <option v-for="(status, idx) in statusOpt" :key="idx" :value="status" :selected=true>
                  {{ status }}
                </option>
              </select>
            </div>
            <input type="submit" class="btn btn-success ml-2" id="buttons" value="Simpan">
          </form>
          <h5 class="text-center text-success mt-2">{{dataSuccess}}</h5>
          <h5 class="text-center text-danger">{{dataErr}}</h5>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: "addLender",
  components: {},
  data() {
    return {
      id: '',
      statusOpt: ['active', 'inactive'],
      lenderForm:{
        name: "",
        phone: "",
        email: "",
        status: "active"
      },
      dataSuccess: "",
      dataErr: ""
    };
  },
  methods: {
    updateLender() {
      this.resetMessage()
      this.$axios.put(`admin/v1/priority/lenders/${this.id}`, this.lenderForm)
      .then(response => {
        this.dataSuccess = "Data User Priority Lender Sukses disimpan";
      })
      .catch(error => {
        this.dataErr = `Data User Priority Lender Gagal disimpan, ${error}`
      })
    },
    resetMessage(){
      this.dataSuccess = "",
      this.dataErr = ""
    }
  },
  created() {
    this.id = this.$route.params.id
    this.$axios.get(`/admin/v1/priority/lenders/${this.id}`)
      .then(response => {
        this.lenderForm = response.data.data
      })
      .catch(error => {
        this.dataErr = error
      });
  }
};
</script>

<style>
#buttons {
  border-radius: 20px;
  width: 80px;
}
</style>